var _path, _rect, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg6Benefiticon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 69,
    height: 69,
    viewBox: "0 0 69 69",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.5034 25.7766C22 26.4937 22 28.6254 22 32.8889V34.9885C22 42.5059 27.6519 46.154 31.1981 47.7031C32.16 48.1233 32.641 48.3334 34 48.3334C35.359 48.3334 35.84 48.1233 36.8019 47.7031C40.348 46.154 46 42.5059 46 34.9885V32.8889C46 28.6254 46 26.4937 45.4966 25.7766C44.9933 25.0594 42.9889 24.3733 38.9801 23.0011L38.2164 22.7396C36.1267 22.0243 35.0819 21.6667 34 21.6667C32.9181 21.6667 31.8733 22.0243 29.7836 22.7396L29.0199 23.0011C25.0111 24.3733 23.0067 25.0594 22.5034 25.7766ZM38.0793 32.9994C38.4471 32.5874 38.4113 31.9552 37.9993 31.5874C37.5874 31.2196 36.9552 31.2554 36.5874 31.6673L32.5714 36.1652L31.4126 34.8673C31.0448 34.4554 30.4126 34.4196 30.0007 34.7874C29.5887 35.1552 29.5529 35.7874 29.9207 36.1994L31.8255 38.3327C32.0152 38.5452 32.2866 38.6667 32.5714 38.6667C32.8563 38.6667 33.1276 38.5452 33.3174 38.3327L38.0793 32.9994Z",
    fill: "#7957FF"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5.5,
    y: 5.5,
    width: 58,
    height: 58,
    rx: 15.5,
    stroke: "url(#paint0_linear_27_1866)",
    strokeOpacity: 0.3,
    strokeWidth: 11
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_27_1866",
    x1: 34.5,
    y1: 0,
    x2: 34.5,
    y2: 69,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg6Benefiticon);
export default __webpack_public_path__ + "static/media/6 benefit icon.14ba6531dc92fd5c1fa7e5d25aecba19.svg";
export { ForwardRef as ReactComponent };